import { createFileRoute } from '@tanstack/react-router'
import { RealEstateCalendarTab } from '~/components/routes/development/real-estate/calendar/real-estate-calendar-tab'
import { EVENT_READ, realEstateTabGuard } from '~/components/routes/development/real-estate/tabs'

export const Route = createFileRoute('/_authenticated/development/real-estate/calendar')({
  staticData: { permission: EVENT_READ },
  beforeLoad: realEstateTabGuard('calendar'),
  component: RealEstateCalendarTab,
})
